//Modules
import React from "react"
//Styles
import styled from "styled-components"
import { StyledContainer } from "../../Elements"
import { font, flex, spacing } from "../../Utilities"
//Components
import Lesson from "./Lesson"

const DemoLessons = ({ lessons }) => {
  return (
    <StyledContainer>
      <h1>Demo Lessons</h1>
      <StyledDemoLessonsContainer>
        <h2>InTasc Standards</h2>
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur
          officia corrupti culpa neque reprehenderit ullam eligendi, perferendis
          fugit deserunt itaque libero minima eos, quod accusantium sunt
          similique blanditiis inventore laboriosam.
        </p>
        {lessons.map((lesson, i) => {
          return <Lesson key={i} lesson={lesson} />
        })}
      </StyledDemoLessonsContainer>
    </StyledContainer>
  )
}

const StyledDemoLessonsContainer = styled.div`
  ${flex("column", "center", "center")};

  h2 {
    ${font("M")};
    margin-bottom: ${spacing.S};
  }

  p {
    ${font("S")};
    max-width: 800px;
    margin-bottom: ${spacing.M};
  }
`

export default DemoLessons
